// import React, { useState, useRef, useEffect } from "react";
// import * as XLSX from "xlsx";
// import Cookies from "js-cookie";
// import JSZip from "jszip";
// import "./CarUpload.css";
// import InformationModal from "../components/InformationModal";

// const VehicleDataUpload = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [singleVehicle, setSingleVehicle] = useState({
//     registrationNo: "",
//     make: "",
//     model: "",
//     year: "",
//     rcRequired: "",
//     location: "",
//     startPrice: "",
//     startDateAndTime: "",
//     endDateAndTime: "",
//     variant: "",
//     color: "",
//     odometer: "",
//     fuel: "",
//     body: "",
//     seater: "",
//     transmission: "",
//     images: null,
//     insuranceStatus: "",
//     owners: "",
//   });

//   const [excelData, setExcelData] = useState([]);
//   const [excelFile, setExcelFile] = useState(null);
//   const [zipFile, setZipFile] = useState(null);
//   const [pdfFile, setPdfFile] = useState(null);
//   const [pdfZipFile, setPdfZipFile] = useState(null);
//   const [activeForm, setActiveForm] = useState("single");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: "ascending",
//   });
//   const [loading, setLoading] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [isDuplicate, setIsDuplicate] = useState(false);
//   const fileInputRef = useRef(null);
//   const [status, setStatus] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modelMessage, setModalMessage] = useState('');
//   const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
//   const [errors, setErrors] = useState({});

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);
//   const openStatusModal = () => setIsStatusModalOpen(true);
//   const closeStatusModal = () => setIsStatusModalOpen(false);

//   const handleZipFileChange = (e) => {
//     const file = e.target.files[0];
//     setZipFile(file);
//   };

//   const handlePdfFileChange = (e) => {
//     const file = e.target.files[0];
//     setPdfFile(file);
//   };

//   const handlePdfZipFileChange = (e) => {
//     const file = e.target.files[0];
//     setPdfZipFile(file);
//   };

//   const dateRef1 = useRef();
//   const dateRef2 = useRef();

//   const handleFocusFirst = () => {
//     if (dateRef1.current?.showPicker) {
//       dateRef1.current.showPicker();
//     }
//   };

//   const handleFocusSecond = () => {
//     if (dateRef2.current?.showPicker) {
//       dateRef2.current.showPicker();
//     }
//   };

//   const today = new Date().toISOString().split("T")[0];
//   const futureDate = new Date(new Date().setDate(new Date().getDate() + 12)).toISOString().split("T")[0];

//   useEffect(() => {
//     const sellerId = Cookies.get("adminSellerId");
//     if (sellerId) {
//       setSingleVehicle((prevVehicle) => ({
//         ...prevVehicle,
//         sellerId,
//       }));
//     }
//   }, []);

//   const generateAuctionListId = (isMultiVehicle = false) => {
//     const sellerId = Cookies.get("adminSellerId");
//     const currentTime = new Date().getTime();
//     return `${sellerId}_${currentTime}${isMultiVehicle ? "" : "_1"}`;
//   };

//   const validateRegistrationNo = (value) => {
//     if (!value) {
//       return "Registration number is required";
//     }
//     const regex = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;
//     if (!regex.test(value)) {
//       return "Registration number must be in the format: XXYYZZNNNN";
//     }
//     return "";
//   };

//   const validateMakeModel = (value, fieldName) => {
//     if (!value) {
//       return `${fieldName} is required`;
//     }
//     if (value.length < 3) {
//       return `${fieldName} must be at least 3 characters`;
//     }
//     return "";
//   };

//   const handleSingleVehicleChange = (e) => {
//     const { name, value } = e.target;
//     setSingleVehicle((prevVehicle) => ({
//       ...prevVehicle,
//       [name]: value,
//     }));

//     let error = "";
//     switch (name) {
//       case "registrationNo":
//         error = validateRegistrationNo(value);
//         break;
//       case "make":
//         error = validateMakeModel(value, "Make");
//         break;
//       case "model":
//         error = validateMakeModel(value, "Model");
//         break;
//       case "variant":
//         error = !value ? "Variant is required" : "";
//         break;
//       case "year":
//         error = !value ? "Year is required" : "";
//         break;
//     }

//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       [name]: error
//     }));
//   };

//   const checkDuplicateRegistration = async (registrationNo) => {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/checkDuplicate?registrationNo=${registrationNo}`,
//       {
//         credentials: "include",
//         headers: {
//           "X-Full-URL": window.location.href,
//         }
//       }
//     );
//     const data = await response.json();
//     setIsDuplicate(data);
//     if (data) {
//       setIsModalOpen(true);
//       setModalMessage("Duplicate registration number detected.");
//     }
//   };

//   const validateCurrentStepFields = () => {
//     const newErrors = { ...errors };

//     switch (currentStep) {
//       case 1:
//         newErrors.registrationNo = validateRegistrationNo(singleVehicle.registrationNo);
//         newErrors.make = validateMakeModel(singleVehicle.make, "Make");
//         newErrors.model = validateMakeModel(singleVehicle.model, "Model");
//         newErrors.year = !singleVehicle.year ? "Year is required" : "";
//         newErrors.variant = !singleVehicle.variant ? "Variant is required" : "";
//         break;
//     }

//     setErrors(newErrors);
//     return newErrors;
//   };

//   const isCurrentStepValid = () => {
//     const isFilled = (() => {
//       switch (currentStep) {
//         case 1:
//           return (
//             singleVehicle.registrationNo &&
//             singleVehicle.make &&
//             singleVehicle.model &&
//             singleVehicle.year &&
//             singleVehicle.variant
//           );
//         case 2:
//           return (
//             singleVehicle.color &&
//             singleVehicle.odometer &&
//             singleVehicle.fuel &&
//             singleVehicle.body &&
//             singleVehicle.transmission
//           );
//         case 3:
//           return (
//             singleVehicle.location &&
//             singleVehicle.insuranceStatus &&
//             singleVehicle.rcRequired &&
//             singleVehicle.owners
//           );
//         case 4:
//           return (
//             singleVehicle.startPrice &&
//             singleVehicle.startDateAndTime &&
//             singleVehicle.endDateAndTime &&
//             zipFile &&
//             pdfFile
//           );
//         default:
//           return false;
//       }
//     })();

//     const hasErrors = (() => {
//       switch (currentStep) {
//         case 1:
//           return (
//             errors.registrationNo ||
//             errors.make ||
//             errors.model ||
//             errors.year ||
//             errors.variant
//           );
//         case 2:
//           return (
//             errors.color ||
//             errors.odometer ||
//             errors.fuel ||
//             errors.body ||
//             errors.transmission
//           );
//         case 3:
//           return (
//             errors.location ||
//             errors.insuranceStatus ||
//             errors.rcRequired ||
//             errors.owners
//           );
//         case 4:
//           return (
//             errors.startPrice ||
//             errors.startDateAndTime ||
//             errors.endDateAndTime
//           );
//         default:
//           return false;
//       }
//     })();

//     return isFilled && !hasErrors;
//   };

//   const nextStep = () => {
//     const updatedErrors = validateCurrentStepFields();
//     let hasErrors = false;
//     switch (currentStep) {
//       case 1:
//         hasErrors = (
//           updatedErrors.registrationNo ||
//           updatedErrors.make ||
//           updatedErrors.model ||
//           updatedErrors.year ||
//           updatedErrors.variant
//         );
//         break;
//     }

//     if (currentStep < 4 && !hasErrors && isCurrentStepValid()) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const prevStep = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const excelDateToFormattedString = (excelDate) => {
//     const excelEpoch = new Date(1899, 11, 30);
//     const dateInMilliseconds = excelEpoch.getTime() + excelDate * 24 * 60 * 60 * 1000;
//     const date = new Date(dateInMilliseconds);
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${year}-${month}-${day}`;
//   };

//   const convertImageToJpeg = (file) => {
//     return new Promise((resolve, reject) => {
//       const img = new Image();
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           const ctx = canvas.getContext("2d");
//           canvas.width = img.width;
//           canvas.height = img.height;
//           ctx.drawImage(img, 0, 0);
//           canvas.toBlob((blob) => {
//             resolve(
//               new File([blob], `${file.name.split(".")[0]}.jpeg`, {
//                 type: "image/jpeg",
//               })
//             );
//           }, "image/jpeg");
//         };
//         img.src = event.target.result;
//       };
//       reader.onerror = reject;
//       reader.readAsDataURL(file);
//     });
//   };

//   const extractAndConvertImages = async (zipFile) => {
//     const zip = await JSZip.loadAsync(zipFile);
//     const imageFiles = [];
//     const promises = [];

//     zip.forEach((relativePath, file) => {
//       if (!file.dir) {
//         const extension = file.name.split(".").pop().toLowerCase();
//         if (["jpeg", "jpg", "png", "gif", "webp"].includes(extension)) {
//           promises.push(
//             file.async("blob").then((blob) => {
//               return convertImageToJpeg(new File([blob], file.name));
//             })
//           );
//         }
//       }
//     });

//     const convertedImages = await Promise.all(promises);
//     convertedImages.forEach((image) => {
//       if (image) {
//         imageFiles.push(image);
//       }
//     });

//     return imageFiles;
//   };

//   const handleSingleVehicleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isSingleVehicleFormValid()) return;
//     setLoading(true);
//     const auctionListId = generateAuctionListId(false);
//     const sellerId = parseInt(Cookies.get("adminSellerId"), 10);
//     const formData = new FormData();
//     const vehicleData = {
//       registrationNo: singleVehicle.registrationNo,
//       make: singleVehicle.make,
//       model: singleVehicle.model,
//       year: parseInt(singleVehicle.year),
//       variant: singleVehicle.variant,
//       color: singleVehicle.color,
//       odometer: parseInt(singleVehicle.odometer),
//       fuel: singleVehicle.fuel,
//       body: singleVehicle.body,
//       seater: parseInt(singleVehicle.seater),
//       transmission: singleVehicle.transmission,
//       startPrice: parseFloat(singleVehicle.startPrice),
//       startDateAndTime: new Date(
//         `${singleVehicle.startDateAndTime}T00:00:00`
//       ).toISOString(),
//       endDateAndTime: new Date(
//         `${singleVehicle.endDateAndTime}T23:59:59`
//       ).toISOString(),
//       rcRequired: singleVehicle.rcRequired,
//       insuranceStatus: singleVehicle.insuranceStatus,
//       owners: parseInt(singleVehicle.owners),
//       location: singleVehicle.location,
//     };
//     const vehicleDataFile = new File(
//       [JSON.stringify(vehicleData)],
//       "vehicleData.json",
//       { type: "application/json" }
//     );
//     formData.append("vehicleData", vehicleDataFile);
//     if (zipFile) {
//       formData.append("zipFile", zipFile);
//     }
//     if (pdfFile) {
//       formData.append("pdfFile", pdfFile);
//     }
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/insert?sellerId=${sellerId}`,
//         {
//           method: "POST",
//           body: formData,
//           credentials: "include",
//           headers: {
//             "X-Full-URL": window.location.href,
//           }
//         }
//       );
//       if (response.ok) {
//         const data = await response.text();
//         setModalMessage(data);
//         setIsModalOpen(true);
//         setSingleVehicle({
//           registrationNo: "",
//           make: "",
//           model: "",
//           year: "",
//           rcRequired: "",
//           location: "",
//           startPrice: "",
//           startDateAndTime: "",
//           endDateAndTime: "",
//           variant: "",
//           color: "",
//           odometer: "",
//           fuel: "",
//           body: "",
//           seater: "",
//           transmission: "",
//           images: null,
//           insuranceStatus: "",
//           owners: "",
//         });
//         setZipFile(null);
//         setPdfFile(null);
//         setCurrentStep(1);
//       } else {
//         throw new Error("Failed to upload single vehicle data.");
//       }
//     } catch (error) {
//       console.error("Error uploading single vehicle data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleExcelFileChange = (e) => {
//   const file = e.target.files[0];
//   const reader = new FileReader();

//   const expectedHeaders = [
//     "Registration No.",
//     "make",
//     "model",
//     "variant",
//     "color",
//     "fuel",
//     "body",
//     "seater",
//     "transmission",
//     "odometer",
//     "year",
//     "RC Status",
//     "Insurance Status",
//     "owners",
//     "location",
//     "base price",
//     "Available start Date",
//     "Available End Date"
//   ];

//   reader.onload = (event) => {
//     const binaryStr = event.target.result;
//     const workbook = XLSX.read(binaryStr, { type: "binary" });
//     const firstSheetName = workbook.SheetNames[0];
//     const worksheet = workbook.Sheets[firstSheetName];
//     const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//     // Check if the headers match the expected headers
//     const actualHeaders = data[0];
//     const headersMatch = expectedHeaders.every((header, index) => {
//       return actualHeaders[index].toLowerCase() === header.toLowerCase();
//     });

//     if (!headersMatch) {
//       setModalMessage("Invalid file Format - Cannot process the data - Refer the template in this page for format");
//       openModal();
//       return;
//     }

//     setExcelData(data);
//     setExcelFile(file);
//   };

//   reader.readAsBinaryString(file);
// };


//   const handleMultiVehicleSubmit = async (e) => {
//     e.preventDefault();
//     if (!excelData.length || !zipFile || !pdfZipFile) {
//       return;
//     }

//     setLoading(true);

//     const sellerId = parseInt(Cookies.get("adminSellerId"), 10);

//     const vehicleDataList = excelData.slice(1).map((row, index) => {
//       const startDate = excelDateToFormattedString(row[16]);
//       const endDate = excelDateToFormattedString(row[17]);

//       if (
//         !row[0] ||
//         !row[1] ||
//         !row[2] ||
//         !row[16] || isNaN(new Date(`${startDate}T00:00:00`).getTime()) ||
//         !row[17] || isNaN(new Date(`${endDate}T23:59:59`).getTime())
//       ) {
//         return null;
//       }

//       return {
//         registrationNo: row[0],
//         make: row[1],
//         model: row[2],
//         variant: row[3],
//         color: row[4],
//         fuel: row[5],
//         body: row[6],
//         seater: row[7],
//         transmission: row[8],
//         odometer: parseInt(row[9]),
//         year: parseInt(row[10]),
//         rcRequired: row[11],
//         insuranceStatus: row[12],
//         owners: parseInt(row[13]),
//         location: row[14],
//         startPrice: parseFloat(row[15]),
//         startDateAndTime: new Date(`${startDate}T00:00:00`).toISOString(),
//         endDateAndTime: new Date(`${endDate}T23:59:59`).toISOString(),
//       };
//     }).filter((vehicle) => vehicle !== null);

//     const formData = new FormData();
//     formData.append(
//       "vehicleDataList",
//       new Blob([JSON.stringify(vehicleDataList)], { type: "application/json" })
//     );
//     formData.append("zipFile", zipFile);
//     formData.append("pdfZipFile", pdfZipFile);

//     const formDataExcel = new FormData();
//     formDataExcel.append("file", excelFile);
//     formDataExcel.append("sellerId", sellerId);

//     try {
//       const excelResponse = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/uploadExcel`,
//         {
//           method: "POST",
//           body: formDataExcel,
//           credentials: "include",
//           headers: {
//             "X-Full-URL": window.location.href,
//           }
//         }
//       );

//       if (!excelResponse.ok) {
//         throw new Error("Failed to upload Excel file.");
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/insert-multiple?sellerId=${sellerId}`,
//         {
//           method: "POST",
//           body: formData,
//           credentials: "include",
//           headers: {
//             "X-Full-URL": window.location.href,
//           }
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         setStatus(data);

//         const hasUploaded = data.some(item => item.includes("Uploaded"));

//         if (hasUploaded) {
//           setModalMessage("Bulk vehicles upload successful. The vehicle images validation/processing will take some time to complete. You will be notified by email once the validation/processing is complete.");
//           openModal();
//         }

//         openStatusModal();
//         setExcelData([]);
//         setZipFile(null);
//         setPdfZipFile(null);
//         setExcelFile(null);
//         if (fileInputRef.current) {
//           fileInputRef.current.value = "";
//         }
//       } else {
//         throw new Error("Failed to upload multi-vehicle data.");
//       }
//     } catch (error) {
//       console.error("Error uploading multi-vehicle data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const closeSuccessPopup = () => {
//     setShowSuccessPopup(false);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const requestSort = (index) => {
//     let direction = "ascending";
//     if (sortConfig.key === index && sortConfig.direction === "ascending") {
//       direction = "descending";
//     }
//     setSortConfig({ key: index, direction });
//   };

//   const getFilteredSortedData = () => {
//     let filteredData = excelData
//       .slice(1)
//       .filter((row) =>
//         row.some((cell) =>
//           cell?.toString().toLowerCase().includes(searchQuery.toLowerCase())
//         )
//       );

//     if (sortConfig.key !== null) {
//       filteredData.sort((a, b) => {
//         if (a[sortConfig.key] < b[sortConfig.key]) {
//           return sortConfig.direction === "ascending" ? -1 : 1;
//         }
//         if (a[sortConfig.key] > b[sortConfig.key]) {
//           return sortConfig.direction === "ascending" ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     return filteredData;
//   };

//   const getYearOptions = () => {
//     const currentYear = new Date().getFullYear();
//     const years = [];
//     for (let i = 0; i < 7; i++) {
//       years.push(currentYear - i);
//     }
//     return years.map((year) => (
//       <option key={year} value={year}>
//         {year}
//       </option>
//     ));
//   };

//   const isSingleVehicleFormValid = () => {
//     const {
//       registrationNo,
//       make,
//       model,
//       year,
//       location,
//       startPrice,
//       startDateAndTime,
//       endDateAndTime,
//       variant,
//       color,
//       odometer,
//       fuel,
//       body,
//       seater,
//       transmission,
//       rcRequired,
//       insuranceStatus,
//       owners,
//     } = singleVehicle;
//     return (
//       registrationNo &&
//       make &&
//       model &&
//       year &&
//       location &&
//       startPrice &&
//       startDateAndTime &&
//       endDateAndTime &&
//       variant &&
//       color &&
//       odometer &&
//       fuel &&
//       body &&
//       seater &&
//       transmission &&
//       rcRequired &&
//       insuranceStatus &&
//       owners &&
//       zipFile
//     );
//   };

//   const renderFormStep = () => {
//     switch (currentStep) {
//       case 1:
//         return (
//           <div className="form-step">
//             <h3>Step 1: Basic Details</h3>
//             <div
//               className="step-content"
//               style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
//             >
//               <div style={{ flex: "1", minWidth: "150px" }}>
//                 <input
//                   type="text"
//                   name="registrationNo"
//                   placeholder="Enter Registration No"
//                   value={singleVehicle.registrationNo}
//                   onChange={handleSingleVehicleChange}
//                   required
//                   style={{ width: "100%" }}
//                 />
//                 {errors.registrationNo && <div className="error-message">{errors.registrationNo}</div>}
//               </div>
//               <div style={{ flex: "1", minWidth: "150px" }}>
//                 <input
//                   type="text"
//                   name="make"
//                   placeholder="Enter Make"
//                   value={singleVehicle.make}
//                   onFocus={() => checkDuplicateRegistration(singleVehicle.registrationNo)}
//                   onChange={handleSingleVehicleChange}
//                   required
//                   style={{ width: "100%" }}
//                 />
//                 {errors.make && <div className="error-message">{errors.make}</div>}
//               </div>
//               <div style={{ flex: "1", minWidth: "150px" }}>
//                 <input
//                   type="text"
//                   name="model"
//                   placeholder="Enter Model"
//                   value={singleVehicle.model}
//                   onChange={handleSingleVehicleChange}
//                   required
//                   style={{ width: "100%" }}
//                 />
//                 {errors.model && <div className="error-message">{errors.model}</div>}
//               </div>
//               <div style={{ flex: "1", minWidth: "150px" }}>
//                 <input
//                   type="text"
//                   name="variant"
//                   placeholder="Enter Variant"
//                   value={singleVehicle.variant}
//                   onChange={handleSingleVehicleChange}
//                   required
//                   style={{ width: "100%" }}
//                 />
//                 {errors.variant && <div className="error-message">{errors.variant}</div>}
//               </div>
//               <div style={{ flex: "1", minWidth: "150px" }}>
//                 <select
//                   name="year"
//                   value={singleVehicle.year}
//                   onChange={handleSingleVehicleChange}
//                   required
//                   style={{ width: "100%" }}
//                 >
//                   <option value="" disabled>
//                     Select Year
//                   </option>
//                   {getYearOptions()}
//                 </select>
//                 {errors.year && <div className="error-message">{errors.year}</div>}
//               </div>
//             </div>
//             <span></span>
//           </div>
//         );
//       case 2:
//         return (
//           <div className="form-step">
//             <h3>Step 2: Car Details</h3>
//             <div
//               className="step-content"
//               style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
//             >
//               <input
//                 type="text"
//                 name="color"
//                 placeholder="Color"
//                 value={singleVehicle.color}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               />
//               <input
//                 type="number"
//                 name="odometer"
//                 placeholder="Odometer (km)"
//                 value={singleVehicle.odometer}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               />
//               <select
//                 name="fuel"
//                 value={singleVehicle.fuel}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select Fuel Type
//                 </option>
//                 <option value="petrol">Petrol</option>
//                 <option value="diesel">Diesel</option>
//                 <option value="hybrid">Hybrid</option>
//                 <option value="CNG">CNG</option>
//               </select>
//               <select
//                 name="body"
//                 value={singleVehicle.body}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select Body Type
//                 </option>
//                 <option value="Sedan">Sedan</option>
//                 <option value="Hatchback">Hatchback</option>
//                 <option value="SUV">SUV</option>
//                 <option value="Coupe">Coupe</option>
//                 <option value="Wagon (Estate)">Wagon (Estate)</option>
//                 <option value="Pickup Truck">Pickup Truck</option>
//                 <option value="Van / Minivan">Van / Minivan</option>
//               </select>
//               <select
//                 name="seater"
//                 value={singleVehicle.seater}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select No. of Seater
//                 </option>
//                 <option value="4">4</option>
//                 <option value="5">5</option>
//                 <option value="6">6</option>
//                 <option value="7">7</option>
//                 <option value="8">8</option>
//                 <option value="9">9</option>
//               </select>
//               <select
//                 name="transmission"
//                 value={singleVehicle.transmission}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select Transmission
//                 </option>
//                 <option value="automatic">Automatic</option>
//                 <option value="manual">Manual</option>
//               </select>
//             </div>
//             <span></span>
//           </div>
//         );
//       case 3:
//         return (
//           <div className="form-step">
//             <h3>Step 3: Specific Details</h3>
//             <div
//               className="step-content"
//               style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
//             >
//               <input
//                 type="text"
//                 name="location"
//                 placeholder="Location"
//                 value={singleVehicle.location}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               />
//               <select
//                 name="insuranceStatus"
//                 value={singleVehicle.insuranceStatus}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select Insurance Status
//                 </option>
//                 <option value="active">Active</option>
//                 <option value="not active">Not Active</option>
//               </select>
//               <select
//                 name="rcRequired"
//                 value={singleVehicle.rcRequired}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select RC Status
//                 </option>
//                 <option value="original">Original</option>
//                 <option value="duplicate">Duplicate</option>
//               </select>
//               <select
//                 name="owners"
//                 value={singleVehicle.owners}
//                 onChange={handleSingleVehicleChange}
//                 required
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <option value="" disabled>
//                   Select Number of Owners
//                 </option>
//                 <option value="1">1st Owner</option>
//                 <option value="2">2nd Owner</option>
//                 <option value="3">3rd Owner</option>
//                 <option value="4">4th Owner</option>
//                 <option value="5">5+ Owners</option>
//               </select>
//             </div>
//             <span></span>
//           </div>
//         );
//       case 4:
//         return (
//           <div className="form-step">
//             <h3>Step 4: Auction Details</h3>
//             <div
//               className="step-content"
//               style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
//             >
//               <div
//                 className="price-input-container"
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <label>Start Price:</label>
//                 <input
//                   type="number"
//                   name="startPrice"
//                   placeholder="Start Price"
//                   value={singleVehicle.startPrice}
//                   onChange={handleSingleVehicleChange}
//                   required
//                   style={{ flex: "1", minWidth: "150px" }}
//                 />
//               </div>
//               <div
//                 className="date-input-container"
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <label>Start Date:</label>
//                 <input
//                   type="date"
//                   ref={dateRef1}
//                   min={today}
//                   name="startDateAndTime"
//                   onClick={handleFocusFirst}
//                   value={singleVehicle.startDateAndTime}
//                   onChange={handleSingleVehicleChange}
//                   required
//                 />
//               </div>
//               <div
//                 className="date-input-container"
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <label>End Date:</label>
//                 <input
//                   type="date"
//                   ref={dateRef2}
//                   min={futureDate}
//                   onClick={handleFocusSecond}
//                   name="endDateAndTime"
//                   value={singleVehicle.endDateAndTime}
//                   onChange={handleSingleVehicleChange}
//                   required
//                 />
//               </div>
//               <div
//                 className="image-input-container"
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <label>Upload Images</label>
//                 <input
//                   type="file"
//                   accept=".zip"
//                   onChange={handleZipFileChange}
//                   required
//                 />
//               </div>
//               <div
//                 className="pdf-input-container"
//                 style={{ flex: "1", minWidth: "150px" }}
//               >
//                 <label>Upload PDF</label>
//                 <input
//                   type="file"
//                   accept=".pdf"
//                   onChange={handlePdfFileChange}
//                   required
//                 />
//               </div>
//             </div>
//             <span></span>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div id="vehicle-upload-container">
//       {activeForm === "single" ?
//         <div style={{ backgroundColor: "#ee373b", borderTopLeftRadius: "18px", borderTopRightRadius: "18px", padding: "5px" }}>
//           <h2 style={{ color: "white", fontWeight: "bold" }}>Individual Upload</h2>
//         </div> :
//         <div style={{ backgroundColor: "#ee373b", borderTopLeftRadius: "18px", borderTopRightRadius: "18px", padding: "5px" }}>
//           <h2 style={{ color: "white", fontWeight: "bold" }}>Bulk Upload</h2>
//         </div>
//       }
//       <InformationModal
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         message={modelMessage}
//       />
//       {isStatusModalOpen && (
//         <div className="status-modal-overlay">
//           <div className="status-modal-content">
//             <div className="status-modal-header">
//               <p style={{ color: "white", margin: "0px 0px", textAlign: "left", fontSize: "18px", fontWeight: "bold" }}>Upload Status</p>
//             </div>
//             <div className="status-modal-body">
//               <ul>
//                 {status.map((item, index) => (
//                   <>
//                     <li key={index} >{item}</li>
//                     <hr color="red" />
//                   </>
//                 ))}
//               </ul>
//             </div>
//             <div style={{ borderTop: "1px solid #ee373b" }}>
//               <p style={{ margin: "10px 0px 0px 10px" }}> * Duplicate entries are ignored.</p>
//             </div>
//             <button
//               className="status-modal-close-btn"
//               onClick={closeStatusModal}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//       <div id="form-toggle" >
//         <label style={{ marginRight: "10px" }} className="radio-label">
//           <input
//             type="radio"
//             name="formType"
//             value="single"
//             checked={activeForm === "single"}
//             onChange={() => {
//               setActiveForm("single");
//               setCurrentStep(1);
//             }}
//           />
//           <span>Single Vehicle</span>
//         </label>

//         <label className="radio-label">
//           <input
//             type="radio"
//             name="formType"
//             value="multi"
//             checked={activeForm === "multi"}
//             onChange={() => setActiveForm("multi")}
//           />
//           <span>Multi Vehicle</span>
//         </label>
//       </div>

//       {activeForm === "single" && (
//         <form id="single-vehicle-form" onSubmit={handleSingleVehicleSubmit}>
//           <div className="progress-bar-container">
//             <div className="progress-bar" style={{ backgroundColor: "white" }}>
//               <div
//                 className="progress-fill"
//                 style={{
//                   width: `${(currentStep / 4) * 100}%`,
//                   backgroundColor: "var(--primary-red)",
//                 }}
//               ></div>
//             </div>
//           </div>

//           {renderFormStep()}

//           <div className="form-navigation">
//             {currentStep > 1 && (
//               <button
//                 type="button"
//                 className="nav-btn prev-btn"
//                 onClick={prevStep}
//               >
//                 ← Previous
//               </button>
//             )}

//             {currentStep < 4 ? (
//               <button
//                 type="button"
//                 className="nav-btn next-btn"
//                 onClick={nextStep}
//                 disabled={!isCurrentStepValid()}
//               >
//                 Next →
//               </button>
//             ) : (
//               <button
//                 type="submit"
//                 className="nav-btn btn btn-danger"
//                 disabled={!isCurrentStepValid()}
//                 style={{ marginLeft: "auto", borderRadius: "7px" }}
//               >
//                 {loading ? "Uploading..." : "Upload"}
//               </button>
//             )}
//           </div>
//         </form>
//       )}
      // {activeForm === "multi" && (
      //   <form id="multi-vehicle-form" onSubmit={handleMultiVehicleSubmit}>
      //     <div className="d-flex justify-content-end" style={{transform:"translateY(-45px)"}}>
      //         <p className="me-2" style={{fontSize:"1rem"}}>Multi Vehicle Upload Template : </p>
      //         <a
      //           href="https://admin.vvendu.in/common_uploads/excel/downloads/Template.xlsx"
      //           download="vehicle_template.xlsx"
      //           className="download-template-btn"
      //           style={{
      //             color: "#ee373b",
      //             cursor: "pointer",
      //             fontSize:"1rem"
      //           }}
      //         >
      //           <b>Download</b>
      //         </a>
      //       </div>
      //     <div className="file-upload-section">
      //       <div className="file-input-container">
      //         <label className="file-label" htmlFor="excel-file-input">
      //           Upload Excel File
      //         </label>
      //         <input
      //           type="file"
      //           id="excel-file-input"
      //           accept=".xlsx"
      //           onChange={handleExcelFileChange}
      //           ref={fileInputRef}
      //           style={{ maxWidth: "40vw" }}
      //           required
      //           className="file-input"
      //         />
      //       </div>

      //       {excelData.length > 1 && (
      //         <>
      //           <div className="file-input-container">
      //             <label className="file-label" htmlFor="zip-file-input">
      //               Upload Image ZIP File
      //             </label>
      //             <input
      //               type="file"
      //               id="zip-file-input"
      //               accept=".zip"
      //               onChange={handleZipFileChange}
      //               required
      //               className="file-input"
      //             />
      //           </div>
      //           {zipFile ?
      //             <div className="file-input-container">
      //               <label className="file-label" htmlFor="pdf-zip-file-input">
      //                 Upload PDF ZIP File
      //               </label>
      //               <input
      //                 type="file"
      //                 id="pdf-zip-file-input"
      //                 accept=".zip"
      //                 onChange={handlePdfZipFileChange}
      //                 required
      //                 className="file-input"
      //               />
      //             </div> :
      //             <div style={{ minWidth: "200px" }}>
      //               <span> </span>
      //             </div>}
      //         </>
      //       )}
      //     </div>
      //     {excelData.length > 1 && (
      //       <div id="scrollable-table-container" style={{ maxHeight: "33vh", overflowY: "auto", scrollbarWidth: "thin", scrollbarColor: "#ee373b #fefefe" }}>
      //         <table id="excel-data-table" className="table table-striped">
      //           <thead>
      //             <tr>
      //               {[
      //                 "Reg. No.",
      //                 "Year",
      //                 "Make",
      //                 "Model",
      //                 "Variant",
      //                 "Location",
      //                 "Price",
      //                 "Available From",
      //                 "Available Till",
      //               ].map((header, index) => (
      //                 <th key={index}>{header}</th>
      //               ))}
      //             </tr>
      //           </thead>
      //           <tbody>
      //             {getFilteredSortedData().map((row, rowIndex) => (
      //               <tr key={rowIndex}>
      //                 <td>{row[0]}</td>
      //                 <td>{row[10]}</td>
      //                 <td>{row[1]}</td>
      //                 <td>{row[2]}</td>
      //                 <td>{row[3]}</td>
      //                 <td>{row[14]}</td>
      //                 <td>{row[15]}</td>
      //                 <td>
      //                   {excelDateToFormattedString(row[16])}
      //                 </td>
      //                 <td>
      //                   {excelDateToFormattedString(row[17])}
      //                 </td>
      //               </tr>
      //             ))}
      //           </tbody>
      //         </table>
      //       </div>
      //     )}
      //     {excelData.length > 1 && zipFile && pdfZipFile && (
      //       <div className="d-flex justify-content-end mt-3">
      //         <button
      //           type="submit"
      //           id="multi-vehicle-submit-btn"
      //           disabled={
      //             !excelData.length || !zipFile || !pdfZipFile || loading
      //           }
      //         >
      //           {loading ? "Uploading..." : "Upload"}
      //         </button>
      //       </div>
      //     )}
      //   </form>
      // )}

//       {showSuccessPopup && (
//         <div className="success-popup">
//           <div className="success-popup-content">
//             <span className="close-btn" onClick={closeSuccessPopup}>
//               &times;
//             </span>
//             <p>{successMessage}</p>
//             {status.length > 0 && (
//               <div style={{ maxHeight: "200px", overflow: "auto" }}>
//                 <ul>
//                   {status.map((car, index) => {
//                     return <li key={index}>{car}</li>;
//                   })}
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {loading && (
//         <div className="loading-overlay">
//           <div class="container-loading">
//             <img class="vvendu-loading" src="https://admin.vvendu.in/logoInitialsTransparent.png" width="100"/>
//             <p>Uploading vehicles, Please wait....</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default VehicleDataUpload;


import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import Cookies from "js-cookie";
import JSZip from "jszip";
import "./CarUpload.css";
import InformationModal from "../components/InformationModal";
import logo from "../assets/logoInitialsTransparent.png";
import templateFile from "../assets/Template.xlsx";

const VehicleDataUpload = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [singleVehicle, setSingleVehicle] = useState({
    registrationNo: "",
    make: "",
    model: "",
    year: "",
    rcRequired: "",
    location: "",
    startPrice: "",
    startDateAndTime: "",
    endDateAndTime: "",
    variant: "",
    color: "",
    odometer: "",
    fuel: "",
    body: "",
    seater: "",
    transmission: "",
    images: null,
    insuranceStatus: "",
    owners: "",
  });
  const [excelData, setExcelData] = useState([]);
  const [excelFile, setExcelFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [zipFile, setZipFile] = useState(null);
  const [pdfZipFile, setPdfZipFile] = useState(null);
  const [activeForm, setActiveForm] = useState("single");
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isDuplicate, setIsDuplicate] = useState(false);
  const fileInputRef = useRef(null);
  const [status, setStatus] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelMessage, setModalMessage] = useState("");
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedImages, setSelectedImages] = useState([]);
  const [loadingStage, setLoadingStage] = useState("");

  const dateRef1 = useRef();
  const dateRef2 = useRef();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openStatusModal = () => setIsStatusModalOpen(true);
  const closeStatusModal = () => setIsStatusModalOpen(false);

  const handlePdfFileChange = (e) => {
    const file = e.target.files[0];
    setPdfFile(file);
  };

  const handlePdfZipFileChange = (e) => {
    const file = e.target.files[0];
    setPdfZipFile(file);
  };

  const handleFocusFirst = () => {
    if (dateRef1.current?.showPicker) {
      dateRef1.current.showPicker();
    }
  };

  const handleFocusSecond = () => {
    if (dateRef2.current?.showPicker) {
      dateRef2.current.showPicker();
    }
  };

  const today = new Date().toISOString().split("T")[0];
  const futureDate = new Date(new Date().setDate(new Date().getDate() + 12))
    .toISOString()
    .split("T")[0];

  useEffect(() => {
    const sellerId = Cookies.get("adminSellerId");
    if (sellerId) {
      setSingleVehicle((prevVehicle) => ({
        ...prevVehicle,
        sellerId,
      }));
    }
  }, []);

  const generateAuctionListId = (isMultiVehicle = false) => {
    const sellerId = Cookies.get("adminSellerId");
    const currentTime = new Date().getTime();
    return `${sellerId}_${currentTime}${isMultiVehicle ? "" : "_1"}`;
  };

  // Enhanced validation function
  const validateRegistrationNo = (value) => {
    if (!value) {
      return "Registration number/ID is required";
    }

    // Check if it's a demo vehicle ID
    if (value.startsWith('DEMO') || value.startsWith('demo')) {
      // More strict validation for demo IDs
      const demoRegex = /^DEMO[A-Z0-9]{2,}$/i;
      if (!demoRegex.test(value)) {
        return "Demo ID must start with DEMO followed by at least 2 alphanumeric characters";
      }
      return "";
    }

    // Original registration number validation
    const regex = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;
    if (!regex.test(value)) {
      return "Registration number must be in the format: XXYYZZNNNN";
    }
    return "";
  };


  const validateMakeModel = (value, fieldName) => {
    if (!value) {
      return `${fieldName} is required`;
    }
    if (value.length < 3) {
      return `${fieldName} must be at least 3 characters`;
    }
    return "";
  };

  const handleSingleVehicleChange = (e) => {
    const { name, value } = e.target;
    setSingleVehicle((prevVehicle) => ({
      ...prevVehicle,
      [name]: value,
    }));
    let error = "";
    switch (name) {
      case "registrationNo":
        error = validateRegistrationNo(value);
        break;
      case "make":
        error = validateMakeModel(value, "Make");
        break;
      case "model":
        error = validateMakeModel(value, "Model");
        break;
      case "variant":
        error = !value ? "Variant is required" : "";
        break;
      case "year":
        error = !value ? "Year is required" : "";
        break;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const checkDuplicateRegistration = async (registrationNo) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/checkDuplicate?registrationNo=${registrationNo}`,
      {
        credentials: "include",
        headers: {
          "X-Full-URL": window.location.href,
        },
      }
    );
    const data = await response.json();
    setIsDuplicate(data);
    if (data) {
      setIsModalOpen(true);
      setModalMessage("Duplicate registration number detected.");
    }
  };

  const validateCurrentStepFields = () => {
    const newErrors = { ...errors };
    switch (currentStep) {
      case 1:
        newErrors.registrationNo = validateRegistrationNo(
          singleVehicle.registrationNo
        );
        newErrors.make = validateMakeModel(singleVehicle.make, "Make");
        newErrors.model = validateMakeModel(singleVehicle.model, "Model");
        newErrors.year = !singleVehicle.year ? "Year is required" : "";
        newErrors.variant = !singleVehicle.variant ? "Variant is required" : "";
        break;
    }
    setErrors(newErrors);
    return newErrors;
  };

  const isCurrentStepValid = () => {
    const isFilled = (() => {
      switch (currentStep) {
        case 1:
          return (
            singleVehicle.registrationNo &&
            singleVehicle.make &&
            singleVehicle.model &&
            singleVehicle.year &&
            singleVehicle.variant
          );
        case 2:
          return (
            singleVehicle.color &&
            singleVehicle.odometer &&
            singleVehicle.fuel &&
            singleVehicle.body &&
            singleVehicle.transmission
          );
        case 3:
          return (
            singleVehicle.location &&
            singleVehicle.insuranceStatus &&
            singleVehicle.rcRequired &&
            singleVehicle.owners
          );
        case 4:
          return (
            singleVehicle.startPrice &&
            singleVehicle.startDateAndTime &&
            singleVehicle.endDateAndTime &&
            selectedImages.length > 0 &&
            pdfFile
          );
        default:
          return false;
      }
    })();
    const hasErrors = (() => {
      switch (currentStep) {
        case 1:
          return (
            errors.registrationNo ||
            errors.make ||
            errors.model ||
            errors.year ||
            errors.variant
          );
        case 2:
          return (
            errors.color ||
            errors.odometer ||
            errors.fuel ||
            errors.body ||
            errors.transmission
          );
        case 3:
          return (
            errors.location ||
            errors.insuranceStatus ||
            errors.rcRequired ||
            errors.owners
          );
        case 4:
          return (
            errors.startPrice ||
            errors.startDateAndTime ||
            errors.endDateAndTime
          );
        default:
          return false;
      }
    })();
    return isFilled && !hasErrors;
  };

  const nextStep = () => {
    const updatedErrors = validateCurrentStepFields();
    let hasErrors = false;
    switch (currentStep) {
      case 1:
        hasErrors =
          updatedErrors.registrationNo ||
          updatedErrors.make ||
          updatedErrors.model ||
          updatedErrors.year ||
          updatedErrors.variant;
        break;
    }
    if (currentStep < 4 && !hasErrors && isCurrentStepValid()) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const excelDateToFormattedString = (excelDate) => {
    const excelEpoch = new Date(1899, 11, 30);
    const dateInMilliseconds =
      excelEpoch.getTime() + excelDate * 24 * 60 * 60 * 1000;
    const date = new Date(dateInMilliseconds);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleImageFilesChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 14) {
      alert("You can upload a maximum of 14 images.");
      return;
    }
    setSelectedImages(files);
  };

  const zipImages = async () => {
    const zip = new JSZip();
    setLoadingStage("zipping");

    // Eagerly read all files into memory
    const fileBuffers = await Promise.all(
      selectedImages.map(async (file) => {
        const arrayBuffer = await file.arrayBuffer();
        const safeName = file.name.replace(/[^\w.-]/g, "_");
        return { name: safeName, buffer: arrayBuffer };
      })
    );

    // Now add to zip (synchronously)
    for (const { name, buffer } of fileBuffers) {
      zip.file(name, buffer);
      console.log("file added =>", name);
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });
    const zipFileForImg = new File([zipBlob], "images.zip", { type: "application/zip" });
    console.log("Created Zip file:", zipFileForImg);
    return zipFileForImg;
  };

  const handleSingleVehicleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isSingleVehicleFormValid()) return;
    setLoading(true);

    setLoadingStage("zipping");
    const imagesZipFile = await zipImages();
    console.log("finished zipping, going to upload.....");
    setLoadingStage("uploading");

    const auctionListId = generateAuctionListId(false);
    const sellerId = parseInt(Cookies.get("adminSellerId"), 10);
    const formData = new FormData();

    const vehicleData = {
      registrationNo: singleVehicle.registrationNo,
      make: singleVehicle.make.trim(),
      model: singleVehicle.model.trim(),
      year: parseInt(singleVehicle.year),
      variant: singleVehicle.variant,
      color: singleVehicle.color,
      odometer: parseInt(singleVehicle.odometer),
      fuel: singleVehicle.fuel,
      body: singleVehicle.body,
      seater: parseInt(singleVehicle.seater),
      transmission: singleVehicle.transmission,
      startPrice: parseFloat(singleVehicle.startPrice),
      startDateAndTime: new Date(
        `${singleVehicle.startDateAndTime}T00:00:00`
      ).toISOString(),
      endDateAndTime: new Date(
        `${singleVehicle.endDateAndTime}T23:59:59`
      ).toISOString(),
      rcRequired: singleVehicle.rcRequired,
      insuranceStatus: singleVehicle.insuranceStatus,
      owners: parseInt(singleVehicle.owners),
      location: singleVehicle.location,
    };
    
    const vehicleDataFile = new File(
      [JSON.stringify(vehicleData)],
      "vehicleData.json",
      { type: "application/json" }
    );

    console.log("formatted the vehicle data");

    formData.append("vehicleData", vehicleDataFile);
    formData.append("zipFile", imagesZipFile);
    if (pdfFile) {
      formData.append("pdfFile", pdfFile);
    }

    console.log("Hitting the API");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/insert?sellerId=${sellerId}`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href,
          },
        }
      );
      if (response.ok) {
        const data = await response.text();
        setModalMessage(data);
        setIsModalOpen(true);
        setSingleVehicle({
          registrationNo: "",
          make: "",
          model: "",
          year: "",
          rcRequired: "",
          location: "",
          startPrice: "",
          startDateAndTime: "",
          endDateAndTime: "",
          variant: "",
          color: "",
          odometer: "",
          fuel: "",
          body: "",
          seater: "",
          transmission: "",
          images: null,
          insuranceStatus: "",
          owners: "",
        });
        setSelectedImages([]);
        setPdfFile(null);
        setCurrentStep(1);
      } else {
        throw new Error("Failed to upload single vehicle data.");
      }
    } catch (error) {
      console.error("Error uploading single vehicle data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExcelFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    const expectedHeaders = [
      "Registration No.",
      "make",
      "model",
      "variant",
      "color",
      "fuel",
      "body",
      "seater",
      "transmission",
      "odometer",
      "year",
      "RC Status",
      "Insurance Status",
      "owners",
      "location",
      "base price",
      "Available start Date",
      "Available End Date",
    ];
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const actualHeaders = data[0];
      const headersMatch = expectedHeaders.every((header, index) => {
        return (
          actualHeaders[index].toLowerCase() === header.toLowerCase()
        );
      });
      if (!headersMatch) {
        setModalMessage(
          "Invalid file Format - Cannot process the data - Refer the template in this page for format"
        );
        openModal();
        return;
      }
      setExcelData(data);
      setExcelFile(file);
    };
    reader.readAsBinaryString(file);
  };

  const handleZipFileChange = (e) => {
    const file = e.target.files[0];
    setZipFile(file);
  };

const handleMultiVehicleSubmit = async (e) => {
    e.preventDefault();
    if (!excelData.length || !zipFile || !pdfZipFile) {
      return;
    }

    setLoading(true);

    const sellerId = parseInt(Cookies.get("adminSellerId"), 10);

    const vehicleDataList = excelData.slice(1).map((row, index) => {
      const startDate = excelDateToFormattedString(row[16]);
      const endDate = excelDateToFormattedString(row[17]);

      if (
        !row[0] ||
        !row[1] ||
        !row[2] ||
        !row[16] || isNaN(new Date(`${startDate}T00:00:00`).getTime()) ||
        !row[17] || isNaN(new Date(`${endDate}T23:59:59`).getTime())
      ) {
        return null;
      }

      return {
        registrationNo: row[0],
        make: row[1],
        model: row[2],
        variant: row[3],
        color: row[4],
        fuel: row[5],
        body: row[6],
        seater: row[7],
        transmission: row[8],
        odometer: parseInt(row[9]),
        year: parseInt(row[10]),
        rcRequired: row[11],
        insuranceStatus: row[12],
        owners: parseInt(row[13]),
        location: row[14],
        startPrice: parseFloat(row[15]),
        startDateAndTime: new Date(`${startDate}T00:00:00`).toISOString(),
        endDateAndTime: new Date(`${endDate}T23:59:59`).toISOString(),
      };
    }).filter((vehicle) => vehicle !== null);

    const formData = new FormData();
    formData.append(
      "vehicleDataList",
      new Blob([JSON.stringify(vehicleDataList)], { type: "application/json" })
    );
    formData.append("zipFile", zipFile);
    formData.append("pdfZipFile", pdfZipFile);

    const formDataExcel = new FormData();
    formDataExcel.append("file", excelFile);
    formDataExcel.append("sellerId", sellerId);

    try {
      const excelResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/uploadExcel`,
        {
          method: "POST",
          body: formDataExcel,
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href,
          }
        }
      );

      if (!excelResponse.ok) {
        throw new Error("Failed to upload Excel file.");
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/insert-multiple?sellerId=${sellerId}`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href,
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        setStatus(data);

        const hasUploaded = data.some(item => item.includes("Uploaded"));

        if (hasUploaded) {
          setModalMessage("Bulk vehicles upload successful. The vehicle images validation/processing will take some time to complete. You will be notified by email once the validation/processing is complete.");
          openModal();
        }

        openStatusModal();
        setExcelData([]);
        setZipFile(null);
        setPdfZipFile(null);
        setExcelFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        throw new Error("Failed to upload multi-vehicle data.");
      }
    } catch (error) {
      console.error("Error uploading multi-vehicle data:", error);
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessPopup = () => {
    setShowSuccessPopup(false);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const requestSort = (index) => {
    let direction = "ascending";
    if (sortConfig.key === index && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: index, direction });
  };

  const getFilteredSortedData = () => {
    let filteredData = excelData
      .slice(1)
      .filter((row) =>
        row.some((cell) =>
          cell
            ?.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        )
      );
    if (sortConfig.key !== null) {
      filteredData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return filteredData;
  };

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 12; i++) {
      years.push(currentYear - i);
    }
    return years.map((year) => (
      <option key={year} value={year}>
        {year}
      </option>
    ));
  };

  const isSingleVehicleFormValid = () => {
    const {
      registrationNo,
      make,
      model,
      year,
      location,
      startPrice,
      startDateAndTime,
      endDateAndTime,
      variant,
      color,
      odometer,
      fuel,
      body,
      seater,
      transmission,
      rcRequired,
      insuranceStatus,
      owners,
    } = singleVehicle;
    return (
      registrationNo &&
      make &&
      model &&
      year &&
      location &&
      startPrice &&
      startDateAndTime &&
      endDateAndTime &&
      variant &&
      color &&
      odometer &&
      fuel &&
      body &&
      seater &&
      transmission &&
      rcRequired &&
      insuranceStatus &&
      owners &&
      selectedImages.length > 0 &&
      pdfFile
    );
  };

  const renderFormStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="form-step">
            <h3>Step 1: Basic Details</h3>
            <div
              className="step-content"
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              <div style={{ flex: "1", minWidth: "150px" }}>
                <input
                  type="text"
                  name="registrationNo"
                  placeholder="Enter Registration No"
                  value={singleVehicle.registrationNo}
                  onChange={handleSingleVehicleChange}
                  required
                  style={{ width: "100%" }}
                />
                {errors.registrationNo && (
                  <div className="error-message">
                    {errors.registrationNo}
                  </div>
                )}
              </div>
              <div style={{ flex: "1", minWidth: "150px" }}>
                <input
                  type="text"
                  name="make"
                  placeholder="Enter Make"
                  value={singleVehicle.make}
                  onFocus={() =>
                    checkDuplicateRegistration(singleVehicle.registrationNo)
                  }
                  onChange={handleSingleVehicleChange}
                  required
                  style={{ width: "100%" }}
                />
                {errors.make && (
                  <div className="error-message">{errors.make}</div>
                )}
              </div>
              <div style={{ flex: "1", minWidth: "150px" }}>
                <input
                  type="text"
                  name="model"
                  placeholder="Enter Model"
                  value={singleVehicle.model}
                  onChange={handleSingleVehicleChange}
                  required
                  style={{ width: "100%" }}
                />
                {errors.model && (
                  <div className="error-message">{errors.model}</div>
                )}
              </div>
              <div style={{ flex: "1", minWidth: "150px" }}>
                <input
                  type="text"
                  name="variant"
                  placeholder="Enter Variant"
                  value={singleVehicle.variant}
                  onChange={handleSingleVehicleChange}
                  required
                  style={{ width: "100%" }}
                />
                {errors.variant && (
                  <div className="error-message">{errors.variant}</div>
                )}
              </div>
              <div style={{ flex: "1", minWidth: "150px" }}>
                <select
                  name="year"
                  value={singleVehicle.year}
                  onChange={handleSingleVehicleChange}
                  required
                  style={{ width: "100%" }}
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {getYearOptions()}
                </select>
                {errors.year && (
                  <div className="error-message">{errors.year}</div>
                )}
              </div>
            </div>
            <span></span>
          </div>
        );
      case 2:
        return (
          <div className="form-step">
            <h3>Step 2: Car Details</h3>
            <div
              className="step-content"
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              <input
                type="text"
                name="color"
                placeholder="Color"
                value={singleVehicle.color}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              />
              <input
                type="number"
                name="odometer"
                placeholder="Odometer (km)"
                value={singleVehicle.odometer}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              />
              <select
                name="fuel"
                value={singleVehicle.fuel}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select Fuel Type
                </option>
                <option value="petrol">Petrol</option>
                <option value="diesel">Diesel</option>
                <option value="hybrid">Hybrid</option>
                <option value="CNG">CNG</option>
              </select>
              <select
                name="body"
                value={singleVehicle.body}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select Body Type
                </option>
                <option value="Sedan">Sedan</option>
                <option value="Hatchback">Hatchback</option>
                <option value="SUV">SUV</option>
                <option value="Coupe">Coupe</option>
                <option value="Wagon (Estate)">Wagon (Estate)</option>
                <option value="Pickup Truck">Pickup Truck</option>
                <option value="Van / Minivan">Van / Minivan</option>
              </select>
              <select
                name="seater"
                value={singleVehicle.seater}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select No. of Seater
                </option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </select>
              <select
                name="transmission"
                value={singleVehicle.transmission}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select Transmission
                </option>
                <option value="automatic">Automatic</option>
                <option value="manual">Manual</option>
              </select>
            </div>
            <span></span>
          </div>
        );
      case 3:
        return (
          <div className="form-step">
            <h3>Step 3: Specific Details</h3>
            <div
              className="step-content"
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              <input
                type="text"
                name="location"
                placeholder="Location"
                value={singleVehicle.location}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              />
              <select
                name="insuranceStatus"
                value={singleVehicle.insuranceStatus}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select Insurance Status
                </option>
                <option value="active">Active</option>
                <option value="not active">Not Active</option>
              </select>
              <select
                name="rcRequired"
                value={singleVehicle.rcRequired}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select RC Status
                </option>
                <option value="original">Original</option>
                <option value="duplicate">Duplicate</option>
              </select>
              <select
                name="owners"
                value={singleVehicle.owners}
                onChange={handleSingleVehicleChange}
                required
                style={{ flex: "1", minWidth: "150px" }}
              >
                <option value="" disabled>
                  Select Number of Owners
                </option>
                <option value="1">1st Owner</option>
                <option value="2">2nd Owner</option>
                <option value="3">3rd Owner</option>
                <option value="4">4th Owner</option>
                <option value="5">5+ Owners</option>
              </select>
            </div>
            <span></span>
          </div>
        );
      case 4:
        return (
          <div className="form-step">
            <h3>Step 4: Auction Details</h3>
            <div
              className="step-content"
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              <div
                className="price-input-container"
                style={{ flex: "1", minWidth: "150px" }}
              >
                <label>Start Price:</label>
                <input
                  type="number"
                  name="startPrice"
                  placeholder="Start Price"
                  value={singleVehicle.startPrice}
                  onChange={handleSingleVehicleChange}
                  required
                />
              </div>
              <div
                className="date-input-container"
                style={{ flex: "1", minWidth: "150px" }}
              >
                <label>Start Date:</label>
                <input
                  type="date"
                  ref={dateRef1}
                  min={today}
                  name="startDateAndTime"
                  onClick={handleFocusFirst}
                  value={singleVehicle.startDateAndTime}
                  onChange={handleSingleVehicleChange}
                  required
                />
              </div>
              <div
                className="date-input-container"
                style={{ flex: "1", minWidth: "150px" }}
              >
                <label>End Date:</label>
                <input
                  type="date"
                  ref={dateRef2}
                  min={futureDate}
                  onClick={handleFocusSecond}
                  name="endDateAndTime"
                  value={singleVehicle.endDateAndTime}
                  onChange={handleSingleVehicleChange}
                  required
                />
              </div>
              <div
                className="image-input-container"
                style={{ flex: "1", minWidth: "150px" }}
              >
                <label>Upload Images (Max 14)</label>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleImageFilesChange}
                  required
                />
                {/* {selectedImages.length > 0 && (
                  <div className="image-preview">
                    <h4>Selected Images:</h4>
                    <div className="image-grid">
                      {selectedImages.map((image, index) => (
                        <img
                          key={index}
                          src={URL.createObjectURL(image)}
                          alt={`Preview ${index + 1}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            margin: "5px",
                          }}
                        />
                      ))}
                    </div>
                  </div>
                )} */}
              </div>
              <div
                className="pdf-input-container"
                style={{ flex: "1", minWidth: "150px" }}
              >
                <label>Upload PDF</label>
                <input
                  type="file"
                  accept=".pdf"
                  onChange={handlePdfFileChange}
                  required
                />
              </div>
            </div>
            <span></span>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div id="vehicle-upload-container">
      {activeForm === "single" ? (
        <div
          style={{
            backgroundColor: "#ee373b",
            borderTopLeftRadius: "18px",
            borderTopRightRadius: "18px",
            padding: "5px",
          }}
        >
          <h2 style={{ color: "white", fontWeight: "bold" }}>
            Individual Upload
          </h2>
        </div>
      ) : (
        <div
          style={{
            backgroundColor: "#ee373b",
            borderTopLeftRadius: "18px",
            borderTopRightRadius: "18px",
            padding: "5px",
          }}
        >
          <h2 style={{ color: "white", fontWeight: "bold" }}>Bulk Upload</h2>
        </div>
      )}
      <InformationModal
        isOpen={isModalOpen}
        onClose={closeModal}
        message={modelMessage}
      />
      {isStatusModalOpen && (
        <div className="status-modal-overlay">
          <div className="status-modal-content">
            <div className="status-modal-header">
              <p
                style={{
                  color: "white",
                  margin: "0px 0px",
                  textAlign: "left",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                Upload Status
              </p>
            </div>
            <div className="status-modal-body">
              <ul>
                {status.map((item, index) => (
                  <>
                    <li key={index}>{item}</li>
                    <hr color="red" />
                  </>
                ))}
              </ul>
            </div>
            <div style={{ borderTop: "1px solid #ee373b" }}>
              <p style={{ margin: "10px 0px 0px 10px" }}>
                {" "}
                * Duplicate entries are ignored.
              </p>
            </div>
            <button
              className="status-modal-close-btn"
              onClick={closeStatusModal}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <div id="form-toggle">
        <label style={{ marginRight: "10px" }} className="radio-label">
          <input
            type="radio"
            name="formType"
            value="single"
            checked={activeForm === "single"}
            onChange={() => {
              setActiveForm("single");
              setCurrentStep(1);
            }}
          />
          <span>Single Vehicle</span>
        </label>
        <label className="radio-label">
          <input
            type="radio"
            name="formType"
            value="multi"
            checked={activeForm === "multi"}
            onChange={() => setActiveForm("multi")}
          />
          <span>Multi Vehicle</span>
        </label>
      </div>
      {activeForm === "single" && (
        <form id="single-vehicle-form" onSubmit={handleSingleVehicleSubmit}>
          <div className="progress-bar-container">
            <div className="progress-bar" style={{ backgroundColor: "white" }}>
              <div
                className="progress-fill"
                style={{
                  width: `${(currentStep / 4) * 100}%`,
                  backgroundColor: "var(--primary-red)",
                }}
              ></div>
            </div>
          </div>
          {renderFormStep()}
          <div className="form-navigation">
            {currentStep > 1 && (
              <button
                type="button"
                className="nav-btn prev-btn"
                onClick={prevStep}
              >
                ← Previous
              </button>
            )}
            {currentStep < 4 ? (
              <button
                type="button"
                className="nav-btn next-btn"
                onClick={nextStep}
                disabled={!isCurrentStepValid()}
              >
                Next →
              </button>
            ) : (
              <button
                type="submit"
                className="nav-btn btn btn-danger"
                disabled={!isCurrentStepValid()}
                style={{ marginLeft: "auto", borderRadius: "7px" }}
              >
                {loading ? "Uploading..." : "Upload"}
              </button>
            )}
          </div>
        </form>
      )}
      {activeForm === "multi" && (
        <form id="multi-vehicle-form" onSubmit={handleMultiVehicleSubmit}>
          <div className="d-flex justify-content-end" style={{transform:"translateY(-45px)"}}>
              <p className="me-2" style={{fontSize:"1rem"}}>Multi Vehicle Upload Template : </p>
              <a
                href={templateFile}
                download="vehicle_template.xlsx"
                className="download-template-btn"
                style={{
                  color: "#ee373b",
                  cursor: "pointer",
                  fontSize:"1rem"
                }}
              >
                <b>Download</b>
              </a>
            </div>
          <div className="file-upload-section">
            <div className="file-input-container">
              <label className="file-label" htmlFor="excel-file-input">
                Upload Excel File
              </label>
              <input
                type="file"
                id="excel-file-input"
                accept=".xlsx"
                onChange={handleExcelFileChange}
                ref={fileInputRef}
                style={{ maxWidth: "40vw" }}
                required
                className="file-input"
              />
            </div>

            {excelData.length > 1 && (
              <>
                <div className="file-input-container">
                  <label className="file-label" htmlFor="zip-file-input">
                    Upload Image ZIP File
                  </label>
                  <input
                    type="file"
                    id="zip-file-input"
                    accept=".zip"
                    onChange={handleZipFileChange}
                    required
                    className="file-input"
                  />
                </div>
                {zipFile ?
                  <div className="file-input-container">
                    <label className="file-label" htmlFor="pdf-zip-file-input">
                      Upload PDF ZIP File
                    </label>
                    <input
                      type="file"
                      id="pdf-zip-file-input"
                      accept=".zip"
                      onChange={handlePdfZipFileChange}
                      required
                      className="file-input"
                    />
                  </div> :
                  <div style={{ minWidth: "200px" }}>
                    <span> </span>
                  </div>}
              </>
            )}
          </div>
          {excelData.length > 1 && (
            <div id="scrollable-table-container" style={{ maxHeight: "33vh", overflowY: "auto", scrollbarWidth: "thin", scrollbarColor: "#ee373b #fefefe" }}>
              <table id="excel-data-table" className="table table-striped">
                <thead>
                  <tr>
                    {[
                      "Reg. No.",
                      "Year",
                      "Make",
                      "Model",
                      "Variant",
                      "Location",
                      "Price",
                      "Available From",
                      "Available Till",
                    ].map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {getFilteredSortedData().map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row[0]}</td>
                      <td>{row[10]}</td>
                      <td>{row[1]}</td>
                      <td>{row[2]}</td>
                      <td>{row[3]}</td>
                      <td>{row[14]}</td>
                      <td>{row[15]}</td>
                      <td>
                        {excelDateToFormattedString(row[16])}
                      </td>
                      <td>
                        {excelDateToFormattedString(row[17])}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {excelData.length > 1 && zipFile && pdfZipFile && (
            <div className="d-flex justify-content-end mt-3">
              <button
                type="submit"
                id="multi-vehicle-submit-btn"
                disabled={
                  !excelData.length || !zipFile || !pdfZipFile || loading
                }
              >
                {loading ? "Uploading..." : "Upload"}
              </button>
            </div>
          )}
        </form>
      )}
      {showSuccessPopup && (
        <div className="success-popup">
          <div className="success-popup-content">
            <span className="close-btn" onClick={closeSuccessPopup}>
              &times;
            </span>
            <p>{successMessage}</p>
            {status.length > 0 && (
              <div style={{ maxHeight: "200px", overflow: "auto" }}>
                <ul>
                  {status.map((car, index) => {
                    return <li key={index}>{car}</li>;
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
      {loading && (
        <div className="loading-overlay">
          <div className="container-loading">
            <img
              className="vvendu-loading"
              src={logo}
              width="100"
              alt="Loading"
            />
            <p>
              {loadingStage === "zipping"
                ? "Zipping your image files..."
                : loadingStage === "uploading"
                ? "Uploading Vehicles, Please wait..."
                : "Images are being processed..."}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleDataUpload;
